module.exports = __webpack_public_path__ + "img/case_139_email.b0adcd4f.png";